import type { Direction } from '@mui/material';

/**
 * A Popover's `anchorOrigin` / `transformOrigin` are physical — MUI flips only
 * its own defaults under RTL — so a menu that hangs from a top-bar button's
 * inline end has to name the side for the direction it is in.
 */
export const endEdge = (direction: Direction) => (direction === 'rtl' ? 'left' : 'right');

/** The inline start, for a menu that hangs from the bar's start side. */
export const startEdge = (direction: Direction) => (direction === 'rtl' ? 'right' : 'left');
